<template>
  <div class="expand-collapse" :class="classNames">
    <div class="expand-collapse_header" @click="toggle">
      <div class="expand-collapse_inner">
        <div class="expand-collapse_title">
          <slot name="header">
            <span>{{ show ? $t('Свернуть') : $t('Развернуть') }}</span>
          </slot>
          <i class="expand-collapse_icon" :class="{ 'expand-collapse_icon__open': show }"></i>
        </div>
      </div>
    </div>
    <TransitionExpand>
      <div class="expand-collapse_body" v-show="show">
        <div class="expand-collapse_content">
          <slot></slot>
        </div>
      </div>
    </TransitionExpand>
  </div>
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator'
import TransitionExpand from '../transitions/TransitionExpand.vue'

@Component({
  components: {
    TransitionExpand
  }
})
class ExpandCollapse extends Vue {
  show = false

  toggle () {
    this.show = !this.show
    this.$emit('toggle', this.show)
  }

  @Prop(Boolean) light;

  get classNames () {
    return {
      'expand-collapse__light': this.light
    }
  }
}

export default ExpandCollapse
</script>

<style lang="scss">
  .expand-collapse {

    &__light {
      font: 12px / 1.5 $font-roboto; // for &_header inline-block align
      margin-bottom: 12px;
      @include media_tablet {
        font-size: 18px;
      }

      &:last-child {
        margin-bottom: 0;
      }
    }
    &_header {
      border-bottom: 1px solid rgba(#fff, .2);
      cursor: pointer;
      @include media_tablet {
        border-bottom: none;
      }

      .expand-collapse__light & {
        border-bottom: none;
        display: inline-block;
        padding-right: 10px;
      }
    }
    &_inner {
      @extend %layout;

      .expand-collapse__light & {
        padding: 0;
        max-width: none;
      }
    }
    &_title {
      color: $anchor-color;
      font: 16px / normal $font-roboto;
      padding-bottom: 16px;
      padding-top: 16px;
      padding-right: 15px;
      position: relative;
      transition: color $duration linear;
      @include media_tablet {
        border-bottom: 1px solid rgba(#fff, .2);
        font-size: 18px;
        padding-bottom: 19px;
        padding-top: 19px;
      }
      @include media_desktop {
        font-size: 24px;
      }

      .expand-collapse__light & {
        border-bottom: 1px dashed;
        display: inline-block;
        font: 12px / 1.5 $font-roboto;
        padding: 0;
        @include media_tablet {
          font-size: 16px;
          padding: 0;
        }
      }
      .expand-collapse_header:hover & {
        color: $link-color_hover;
      }
    }
    &_icon {
      border-left: 4px solid transparent;
      border-right: 4px solid transparent;
      border-top: 8px solid;
      position: absolute;
      right: 0;
      top: 23px;
      transition: transform $duration linear;
      @include media_tablet {
        top: 29px;
      }

      .expand-collapse__light & {
        border-left-width: 2px;
        border-right-width: 2px;
        border-top-width: 5px;
        right: -10px;
        top: 7px;
        @include media_tablet {
          top: 11px;
        }
      }
      &__open {
        transform: rotate(180deg);
      }
    }
    &_content {
      @extend %layout;
      padding-bottom: 23px;
      padding-top: 21px;
      @include media_tablet {
        padding-bottom: 32px;
        padding-top: 32px;
      }

      .expand-collapse__light & {
        padding: 17px 0;
        max-width: none;
      }
    }
  }
</style>
